// 报表路由
export default {
  path: "/report",
  name: "report",
  meta: { title: "库存", icon: "report" },
  children: [
    {
      path: "/report/inventoryStatistics",
      name: "inventoryStatistics",
      component: () =>
        import(
          /* webpackChunkName: "inventoryStatistics" */ "@/views/warehouse/inventory/inventoryStatistics"
        ),
      meta: { title: "库存报表", icon: "inventory-real" },
    },
  ],
};
